import fetch from './index';

// 查询当前分类的所有根节点
const getType = (type: string) => fetch.axios_admin.get(`dict/root/${type}`);

// 获取所有课程类型
const getCourseType = () => fetch.axios_admin.get('/course/type/cascader');

// 编辑器上传图片
const addImage = (data: FormData) => fetch.axios_admin.post('/common/image', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

export default {
  getType,
  getCourseType,
  addImage,
};
